import { visuallyHidden } from '@mui/utils'
import brettTheme from './theme'
import AppBar from 'components/AppBar'
import Content from 'components/Content'
import HeroImage from 'components/HeroImage'
import {
  Button,
  InputLabel,
  Stack,
  TextField,
  ThemeProvider,
  Typography,
} from '@mui/material'

export default function Brett() {
  return (
    <ThemeProvider theme={brettTheme}>
      <header>
        <AppBar
          items={[{ label: 'Portfolio' }, { label: 'Resume' }]}
          primaryCTA={{ label: 'Contact' }}
        />
      </header>
      <Content bgColor='gradient'>
        <Stack
          spacing={2}
          useFlexGap
          alignItems='center'
          width={{ xs: '100%', sm: '70%' }}>
          <Stack flexDirection='row' gap={2}>
            <Typography
              variant='h1'
              color='primary.main'
              fontSize='clamp(3rem, 10vw, 3.5rem)'
              ml={2}
              sx={theme => ({
                ...theme.applyStyles('dark', { color: 'primary.light' }),
              })}>
              BRETT
            </Typography>
            <Typography
              variant='h1'
              display='flex'
              alignItems='center'
              fontSize='clamp(3rem, 10vw, 3.5rem)'>
              HERRMANN
            </Typography>
          </Stack>
          <Typography
            textAlign='center'
            color='text.secondary'
            width={{ sm: '100%', md: '80%' }}>
            Award-winning promotional HCP and patient copywriter with nearly 15
            years of experience in pharmaceutical advertising focusing on higher
            science brands specializing in marrying the data, strategy, and
            creative to tell a compelling story.
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            useFlexGap
            pt={2}
            width={{ xs: '100%', sm: '350px' }}>
            <InputLabel htmlFor='email-hero' sx={visuallyHidden}>
              Email
            </InputLabel>
            <TextField
              id='email-hero'
              hiddenLabel
              size='small'
              variant='outlined'
              aria-label='Enter your email address'
              placeholder='Your email address'
              fullWidth
              slotProps={{
                htmlInput: {
                  autoComplete: 'off',
                  'aria-label': 'Enter your email address',
                },
              }}
            />
            <Button
              variant='contained'
              color='primary'
              size='small'
              sx={{ minWidth: 'fit-content' }}>
              Contact
            </Button>
          </Stack>
          <Typography
            variant='caption'
            color='text.secondary'
            textAlign='center'>
            Click "Contact" to email Andrea.
          </Typography>
        </Stack>
        <HeroImage src='https://mui.com/static/screenshots/material-ui/getting-started/templates/dashboard-dark.jpg' />
      </Content>
    </ThemeProvider>
  )
}
